<template>
  <div class="task_log">
    <div class="topSearch">
      <div class="innerSearch">
        <el-input placeholder="输入任务id" v-model="task_tool_search" class="input-with-select" id="topInput">
        </el-input>
      </div>
      <div style="margin: 8px">
        <el-button type="primary" @click="searchTaskToolHandle">搜索</el-button>
      </div>
    </div>
    <div class="log_table">
      <el-table
        :data="task_log_data"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
        >
        </el-table-column>
        <el-table-column
          prop="task_id"
          label="任务ID"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="内容">
        </el-table-column>
        <el-table-column
          prop="time"
          label="创建时间">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型">
        </el-table-column>
      </el-table>
    </div>
    <div class="btomPagin" >
      <div class="innerLeft">{{page}} - <span>{{task_log_data.length}}</span> of <span>{{total}}</span> items</div>
      <div>
        <el-pagination
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getTaskLogList} from "@/api/toolBox";

export default {
  name: "taskLog",
  data(){
    return{
      task_tool_search:'',
      task_log_data:[],
      page:1,
      total:""
    }
  },
  created() {
      this.searchTaskToolHandle()
  },
  methods:{
    getTakLogHandle(){
      getTaskLogList({
        page:this.page,
        pageSize:10,
        searchContent:this.task_tool_search
      }).then(res=>{
        this.task_log_data = res.data
        this.total = res.total
      })
    },
    searchTaskToolHandle(){
      this.page = 1
      this.getTakLogHandle()
    },
    handleCurrentChange(val){
      this.page = val
      this.getTakLogHandle()
    }
  },

}
</script>

<style scoped lang="less">
.task_log{
  .topSearch{
    display: flex;
    .innerSearch{
      margin: 8px;
      width: 20%;
      /deep/.el-cascader{
        line-height: 0;
      }
    }
    .topSeach{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 88px;
      }
      /deep/ .el-input__prefix{
        color: #1F2D42;
      }
      .long_search{
        /deep/.el-input__inner{
          padding-left: 115px!important;
        }
      }
      .long_searchs{
        /deep/.el-input__inner{
          padding-left: 133px!important;
        }
      }
      .innerSearch{
        margin: 8px;
        /deep/.el-cascader{
          line-height: 0;
        }
        .innerTime{
          /deep/.el-input__prefix{
            position: absolute;
            top: 0;
            right: 12px;
            left: auto;
          }
          /deep/ .el-input--prefix .el-input__inner{
            padding-left: 12px;
          }
          /deep/.el-input__icon{
            //position: absolute;
            //right: 12px;
            color: #D65953;
          }
        }
        .from{
          /deep/.el-input__inner{
            padding-left: 75px!important;
          }
        }
        .to{
          /deep/.el-input__inner{
            padding-left: 55px!important;
          }
        }
      }
      .cascader{
        position: relative;
        /deep/.el-input__inner{
          padding-left: 80px;
        }
        .slot{
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }
      .ex{
        width: 300px;
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 110px;
        }
      }
    }
  }
  .log_table{
    margin-top: 16px;
  }
  .btomPagin{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    .innerLeft{
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1F2D42;
      line-height: 20px;
    }
  }
}

</style>
